import { h, Fragment } from 'preact';
import { useEffect } from 'preact/hooks';
// import FocusTrap from 'focus-trap-react';
import Backdrop from '../mini-cart/backdrop';

const Panel = ({
  children,
  alignment = 'right',
  context = null,
  triggers,
  // defaultOpen = false,
  classes = 'w-full h-full',
  showBackdrop = false,
  isOpen,
  setIsOpen,
}) => {
  const { openTriggerEl, closeTriggerEl, toggleEl } = triggers;

  const handleOpenEvent = () => {
    setIsOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const handleCloseEvent = () => {
    setIsOpen(false);
    document.body.style.overflow = '';
  };

  const handleToggleEvent = () => {
    setIsOpen(!isOpen);
  };

  // const trapOptions = {
  //   clickOutsideDeactivates: (e) => {
  //     handleCloseEvent(e);
  //     return true;
  //   },
  //   escapeDeactivates: (e) => {
  //     handleCloseEvent(e);
  //     return true;
  //   },
  // };

  useEffect(() => {
    if (openTriggerEl) {
      openTriggerEl.addEventListener('click', handleOpenEvent);
    }
    if (closeTriggerEl) {
      closeTriggerEl.addEventListener('click', handleCloseEvent);
    }
    if (toggleEl) {
      toggleEl.addEventListener('click', handleToggleEvent);
    }
    if (context) {
      document.addEventListener(`${context}:open`, handleOpenEvent);
      document.addEventListener(`${context}:close`, handleCloseEvent);
    }

    return () => {
      if (openTriggerEl) openTriggerEl.removeEventListener('click', handleOpenEvent);
      if (closeTriggerEl) closeTriggerEl.removeEventListener('click', handleCloseEvent);
      if (toggleEl) toggleEl.removeEventListener('click', handleToggleEvent);
      if (context) {
        document.removeEventListener(`${context}:open`, handleOpenEvent);
        document.removeEventListener(`${context}:close`, handleCloseEvent);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openTriggerEl, closeTriggerEl, toggleEl]);

  return (
    <>
      {showBackdrop && (
        <Backdrop isOpen={isOpen} handleCloseEvent={handleCloseEvent} />
      )}
      <div
        className={`block max-w-panel fixed top-0 bottom-0 transition-transform z-40 bg-white ${
          alignment === 'right' ? 'right-0' : 'left-0'
        } ${isOpen ? 'translate-x-0' : 'translate-x-full'} ${classes}`}
      >
        {isOpen && children}
        {/* {isOpen &&
          (defaultOpen ? (
            <>{children}</>
          ) : (
            <FocusTrap focusTrapOptions={trapOptions}>{children}</FocusTrap>
          ))} */}
      </div>
    </>
  );
};

export default Panel;
